import _implicitStylesheets from "./pagesPicker.css";

import _implicitScopedStylesheets from "./pagesPicker.scoped.css?scoped=true";

import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {h: api_element, t: api_text, gid: api_scoped_id} = $api;
  return [api_element("div", {
    classMap: {
      "pagesPickerContent": true
    },
    styleDecls: [["display", "flex", false], ["flex-direction", "row", false], ["align-items", "stretch", false], ["height", "65vh", false]],
    key: 0
  }, [api_element("div", {
    classMap: {
      "pagesThumbnails": true
    },
    styleDecls: [["width", "70%", false], ["display", "grid", false], ["grid-template-columns", "repeat(4, 90px)", false], ["gap", "8px", false], ["height", "60vh", false], ["overflow-y", "auto", false]],
    context: {
      lwc: {
        dom: "manual"
      }
    },
    key: 1
  }, []), api_element("div", {
    classMap: {
      "pagesSelectRange": true
    },
    styleDecls: [["background-color", "white", false], ["white-space", "nowrap", false], ["width", "30%", false], ["height", "60vh", false], ["overflow", "hidden", false], ["padding-left", "3px", false]],
    key: 2
  }, [api_element("div", {
    styleDecls: [["width", "100%", false], ["text-align", "center", false], ["font-weight", "bold", false]],
    key: 3
  }, [api_text("Selected Pages:")]), api_element("div", {
    styleDecls: [["width", "100%", false]],
    key: 4
  }, [api_element("input", {
    classMap: {
      "selectedRange": true
    },
    styleDecls: [["width", "100%", false]],
    attrs: {
      "disabled": "disabled",
      "placeholder": "Page Selection..."
    },
    key: 5
  }, []), api_element("hr", {
    styleDecls: [["margin", "12px 0", false], ["color", "black", false], ["background-color", "black", false]],
    key: 6
  }, [])]), api_element("div", {
    styleDecls: [["white-space", "normal", false]],
    key: 7
  }, [api_text("Click the thumbnails at left to select pages or use radio buttons below.")]), api_element("div", {
    classMap: {
      "pagesSelectChoices": true
    },
    styleDecls: [["display", "flex", false], ["flex-direction", "column", false], ["margin-top", "16px", false], ["width", "100%", false], ["padding-left", "3px", false]],
    key: 8
  }, [api_element("div", {
    key: 9
  }, [api_element("input", {
    classMap: {
      "pageSelectionAll": true
    },
    attrs: {
      "type": "radio",
      "name": "pageSelection",
      "id": api_scoped_id("pageSelectionAll")
    },
    props: {
      "checked": true,
      "value": "all"
    },
    key: 10
  }, []), api_element("label", {
    styleDecls: [["padding-left", "3px", false]],
    attrs: {
      "for": api_scoped_id("pageSelectionAll")
    },
    key: 11
  }, [api_text("Select All Pages")])]), api_element("div", {
    key: 12
  }, [api_element("input", {
    classMap: {
      "pageSelectionOdd": true
    },
    attrs: {
      "type": "radio",
      "name": "pageSelection",
      "id": api_scoped_id("pageSelectionOdd")
    },
    props: {
      "value": "all"
    },
    key: 13
  }, []), api_element("label", {
    styleDecls: [["padding-left", "3px", false]],
    attrs: {
      "for": api_scoped_id("pageSelectionOdd")
    },
    key: 14
  }, [api_text("Select Odd Pages")])]), api_element("div", {
    key: 15
  }, [api_element("input", {
    classMap: {
      "pageSelectionEven": true
    },
    attrs: {
      "type": "radio",
      "name": "pageSelection",
      "id": api_scoped_id("pageSelectionEven")
    },
    props: {
      "value": "all"
    },
    key: 16
  }, []), api_element("label", {
    styleDecls: [["padding-left", "3px", false]],
    attrs: {
      "for": api_scoped_id("pageSelectionEven")
    },
    key: 17
  }, [api_text("Select Even Pages")])])])])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "zpaper-pagesPicker_pagesPicker"
